import { PropsWithChildren, ReactElement } from "react";
import appTheme from "../../appTheme";
import AntDesignThemeProvider from "./AntDesignThemeProvider";
import StyledThemeProvider from "./StyledThemeProvider";

/**
 * Handles the Ant Design and styled-components theme providers.
 *
 * No dependencies.
 */
export default function ThemeProviders({ children }: PropsWithChildren): ReactElement {
  return (
    <AntDesignThemeProvider theme={appTheme}>
      <StyledThemeProvider>
        {children}
      </StyledThemeProvider>
    </AntDesignThemeProvider>
  );
}
